import axios from "axios";
import { getLocaleFromCookies } from "@/utils/cookies";
import Cookies from "js-cookie"; 
import { clearUserSession } from "./session";

const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL || "https://inc-api.indoinvite.com";

export const apiClient = axios.create({
    baseURL: baseUrl,
    timeout: 10000,
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true, 
});

apiClient.interceptors.request.use(
  (config) => {
    const locale = getLocaleFromCookies();
    if (locale) {
        config.headers['Accept-Language'] = locale;
    }
    const token = Cookies.get("auth_token");
    if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      const isCollabRoute =
        typeof window !== "undefined" &&
        window.location.pathname.includes("/collab");

    
      if (isCollabRoute) {
        return Promise.reject(error);
      }

      console.warn("Sesi kedaluwarsa (401). Mengalihkan ke login...");

      clearUserSession();
      Cookies.remove("auth_token");

      if (typeof window !== "undefined") {
        const locale = getLocaleFromCookies();
        const localePrefix = locale === "en" ? "/en" : "";
        window.location.href = `${localePrefix}/login`;
      }
    }

    return Promise.reject(error);
  }
);